// Input rules per method (contract: email/sms/totp = 6 digits; tin = SSN/TIN last 4). No recovery codes since
// docs/specs/mfa-ux-cleanup.md §1: any other method is held to 6 digits and so never sends a recovery code.
export const isTin = (method) => method === "tin";
export const maxLength = (method) => (isTin(method) ? 4 : 6);

// Strip anything the method cannot contain, as the user types.
export const sanitizeCode = (method, raw) => String(raw).replace(/\D/g, "").slice(0, maxLength(method));

// Returns the code to send, or null when it is not valid for the method.
export const normaliseCode = (method, raw) => {
  const code = String(raw ?? "").replace(/\s/g, "");
  if (isTin(method)) return /^[0-9]{4}$/.test(code) ? code : null;
  return /^[0-9]{6}$/.test(code) ? code : null;
};
